<template>
  <transition name="fade">
    <div>
      <div class="pop-up-bg" @click.prevent="$emit('close', false)"></div>
      <div class="pop-up pop-up--delete">
        <a
          class="pop-up__close icon icon-close"
          @click.prevent="$emit('close', false)"
        ></a>
        <h2>{{ list.name.name }}</h2>
        <h4 style="color: red; margin-bottom: 10px" v-if="empty">
          Заповніть поля
        </h4>
        <div class="block-list">
          <div v-show="list.mod == 'delete'">
            <div class="img warning"></div>
            <h3>
              <span>В</span>и впевнені, що хочете видалити {{ list.name.name }}?
            </h3>
          </div>
          <!-- <div v-show="list.mod == 'copy'">
            
            <div class="img copy"></div>
            <h3><span>В</span>и впевнені, що хочете скопіювати {{list.name.name}}?</h3>


          </div> -->
          <div v-show="list.mod !== 'delete'">
            <!-- direction -->
            <div v-if="list.name.mode == 'directions'">
              <div class="form__row form__row-50">
                <DataInput
                  :data="{
                    data: directions.uploadDateFrom,
                    input: 'uploadDateFrom',
                    name: 'Дата завантаження з',
                  }"
                  @resultData="dataInput"
                />
                <DataInput
                  :data="{
                    data: directions.uploadDateOn,
                    min: directions.uploadDateFrom,
                    input: 'uploadDateOn',
                    name: 'Дата завантаження по',
                  }"
                  @resultData="dataInput"
                />
              </div>

              <div class="form__row form__row-50">
                <DataInput
                  :data="{
                    data: directions.unloadingDateFrom,
                    min: directions.uploadDateFrom,
                    input: 'unloadingDateFrom',
                    name: 'Дата розвантаження з',
                  }"
                  @resultData="dataInput"
                />
                <DataInput
                  :data="{
                    data: directions.unloadingDateOn,
                    min: directions.unloadingDateFrom,
                    input: 'unloadingDateOn',
                    name: 'Дата розвантаження по',
                  }"
                  @resultData="dataInput"
                />
              </div>

              <Autocomplete
                :data="{
                  name: 'Контрагент',
                  mod: 'counterparties',
                  key: 'counterparties',
                  idClient: list.client_id,
                  input: directions.counterparties,
                  inputId: directions.counterparties_id,
                }"
                @result="autocompleteResult"
              />

              <div class="form__row form__row--download">
                <a
                  @click.prevent="openTemplates('download')"
                >Шаблони пунктів завантаження
                  <div class="download"></div>
                </a>
              </div>

              <Autocomplete
                :data="{
                  name: 'Пункт завантаження',
                  mod: 'city',
                  key: 'downloadPoint',
                  input: directions.downloadPoint,
                  inputId: directions.downloadPoint_id,
                  img: directions.downloadPoint_img,
                }"
                @result="autocompleteResult"
              />

              <div class="form__input">
                <p class="form__input__textarea-p min" style="font-size: 16px !important">
                  {{ directions.addressDownload }}
                </p>
                <textarea
                  class="form__input__textarea"
                  type="text"
                  v-model="directions.addressDownload"
                />
                <span>Адреса завантаження</span>
              </div>

              <div class="form__input">
                <p class="form__input__textarea-p min" style="font-size: 16px !important">
                  {{ directions.addressClearanceIn }}
                </p>
                <textarea
                  class="form__input__textarea"
                  type="text"
                  v-model="directions.addressClearanceIn"
                />
                <span>Адреса замитнення</span>
              </div>

              <div class="form__row form__row--download">
                <a
                  @click.prevent="openTemplates('unloading')"
                >Шаблони адрес розвантаження
                  <div class="download"></div
                ></a>
              </div>

              <Autocomplete
                :data="{
                  name: 'Пункт розвантаження',
                  mod: 'city',
                  key: 'unloadingPoint',
                  input: directions.unloadingPoint,
                  inputId: directions.unloadingPoint_id,
                  img: directions.unloadingPoint_img,
                }"
                @result="autocompleteResult"
              />

              <div class="form__input">
                <p class="form__input__textarea-p min" style="font-size: 16px !important">
                  {{ directions.addressUnloading }}
                </p>
                <textarea
                  class="form__input__textarea"
                  type="text"
                  v-model="directions.addressUnloading"
                />
                <span>Адреса розвантаження</span>
              </div>

              <div class="form__input">
                <p class="form__input__textarea-p min" style="font-size: 16px !important">
                  {{ directions.addressClearanceOut }}
                </p>
                <textarea
                  class="form__input__textarea"
                  type="text"
                  v-model="directions.addressClearanceOut"
                />
                <span>Адреса розмитнення</span>
              </div>

              <div class="form__input">
                <input type="text" v-model="directions.cargo" />
                <span>Вантаж</span>
              </div>

              <div class="form__input">
                <select v-model="directions.download_type">
                  <option
                    v-for="(type, index) in download_type"
                    :key="index"
                    :value="index + 1"
                  >
                    {{ type }}
                  </option>
                </select>
                <span>Тип завантаження</span>
                <div class="icon icon-arrow-down"></div>
              </div>

              <Autocomplete
                :data="{
                  name: 'Юридична особа',
                  mod: 'legalPersons',
                  key: 'legalEntity',
                  idContractor: application.main_carrier_id,
                  input: directions.legalEntity,
                  inputId: directions.legalEntity_id,
                }"
                @result="autocompleteResult"
              />
              
            </div>

            <!-- freight -->
            <form class="form" v-if="list.name.mode == 'freight'">
              <Autocomplete
                :data="{
                  name: 'Послуга',
                  mod: 'services',
                  key: 'servant',
                  input: freight.servant,
                  inputId: freight.servant_id,
                }"
                @result="autocompleteResult"
              />

              <div class="form__input">
                <p class="form__input__textarea-p">{{ freight.comment }}</p>
                <textarea
                  class="form__input__textarea"
                  type="text"
                  v-model="freight.comment"
                />
                <span>Коментарі</span>
              </div>

              <DataInput
                :data="{ data: freight.date, input: 'date', name: 'Дата' }"
                @resultData="dataInput"
              />

              <div class="form__row form__row-50">

                <div class="form__input">
                  <select v-model="freight.payment_type">
                    <option value="1">Кэш або готівка</option>
                    <option value="2">Безнал</option>
                  </select>
                  <span>Cпосіб оплати</span>
                  <div class="icon icon-arrow-down"></div>
                </div>


                <div class="form__input">
                  <select
                    v-model="freight.currency_payment"
                  >
                    <option
                      v-for="(type, index) in currency"
                      :key="index"
                      :value="type.id"
                    >
                      {{ type.name }}
                    </option>
                  </select>
                  <span>Валюта оплати</span>
                  <div class="icon icon-arrow-down"></div>
                </div>


              </div>


              <div class="form__row form__row-50">
                <div class="form__input">
                  <input
                    type="number"
                    v-model="freight.sum"
                    @input="freightCurrency(freight.currency, 'sum')"
                  />
                  <span>Сума</span>
                </div>

                <div class="form__input">
                  <select
                    v-model="freight.currency"
                    @change="freightCurrency(freight.currency)"
                  >
                    <option
                      v-for="(type, index) in currency"
                      :key="index"
                      :value="type.id"
                    >
                      {{ type.name }}
                    </option>
                  </select>
                  <span>Валюта</span>
                  <div class="icon icon-arrow-down"></div>
                </div>
              </div>

              <div class="form__row form__row-50">
                <div class="form__input">
                  <input
                    type="number"
                    v-model="freight.course"
                    @input="freightCurrencyOTK(freight.course)"
                  />
                  <span>Курс</span>
                </div>

                <div class="form__input">
                  <input type="text" readonly v-model="freight.summFull" />
                  <span>Сума УЕ</span>
                </div>
              </div>
            </form>

            <!-- kickbacks -->
            <form class="form" v-if="list.name.mode == 'kickbacks'">
              <Autocomplete
                v-if="list.client_id !== '0'"
                :data="{
                  name: 'Контактна особа',
                  mod: 'contact',
                  key: 'contact',
                  input: kickbacks.contact,
                  inputId: kickbacks.contact_id,
                  idClient: list.client_id,
                  typeClient: list.modType == '1' ? 'client' : 'contractor',
                }"
                :hidden="hidden"
                @result="autocompleteResult"
              />

              <div class="form__input">
                <input type="number" v-model="kickbacks.interest" />
                <span>Відсоток</span>
              </div>

              <div class="form__input">
                <input type="number" v-model="kickbacks.numberCard" />
                <span>№ номер карти</span>
              </div>

              

              <DataInput
                v-if="kickbacks.date"
                :data="{ data: kickbacks.date, input: 'date', name: 'Дата' }"
                @resultData="dataInput"
              />


              <div class="form__input">
                <input
                  type="number"
                  v-model="kickbacks.sum"
                  @input="freightCurrencyOTK(kickbacks.course)"
                />
                <span>Сума</span>
              </div>

              <div class="form__row form__row-50">
                <div class="form__input">
                  <select
                    v-model="kickbacks.currency"
                    @change="freightCurrency(kickbacks.currency)"
                  >
                    <option
                      v-for="(type, index) in currency"
                      :key="index"
                      :value="type.id"
                    >
                      {{ type.name }}
                    </option>
                  </select>
                  <span>Валюта</span>
                  <div class="icon icon-arrow-down"></div>
                </div>

                <div class="form__input">
                <select
                  v-model="kickbacks.currency_payment"
                >
                  <option
                    v-for="(type, index) in currency"
                    :key="index"
                    :value="type.id"
                  >
                    {{ type.name }}
                  </option>
                </select>
                <span>Валюта оплати</span>
                <div class="icon icon-arrow-down"></div>
              </div>
              </div>

              <div class="form__row form__row-50">
                <div class="form__input">
                  <input
                    type="number"
                    v-model="kickbacks.course"
                    @input="freightCurrencyOTK(kickbacks.course)"
                  />
                  <span>Курс</span>
                </div>

                <div class="form__input">
                  <input type="text" readonly v-model="kickbacks.summFull" />
                  <span>Сума УЕ</span>
                </div>
              </div>
            </form>

            <!-- requests -->
            <form class="form" v-if="list.name.mode == 'requests'">

              <div class="form__input" v-if="list.modType == '2'">
                <select 
                  v-model="requests.carrier"
                >
                  <option
                    v-for="(type, index) in carrierList"
                    :key="index"
                    :value="type.id"
                  >{{type.name}}</option>
                </select>
                <span>Перевозчик</span>
                <div class="icon icon-arrow-down"></div>
              </div>

              <div class="form__input">
                <input type="number" v-model="requests.freight" />
                <span>Сумма фрахту</span>
              </div>



              <Autocomplete
                :data="{
                  none:
                    requests.carrier == '0' ||
                    requests.carrier == ''
                      ? true
                      : false,
                  idContractor: requests.carrier,
                  name: 'Водій',
                  mod: 'drivers',
                  key: 'drivers',
                  input: requests.drivers,
                  inputId: requests.drivers_id,
                }"
                @result="autocompleteResult"
              />

              <Autocomplete
                :data="{
                  none: requests.carrier == '0' ||
                    requests.carrier == ''
                      ? true
                      : false,
                  idContractor: requests.carrier,
                  name: 'Машина',
                  mod: 'car',
                  key: 'car',
                  input: requests.car,
                  inputId: requests.car_id,
                }"
                @result="autocompleteResult"
              />
            </form>
          </div>
        </div>

        <div class="block-btn" v-if="list.mod == 'copy'">
          <a class="btn btn-primary" @click.prevent="save()">Cкопіювати</a>
          <a class="btn btn-secondary" @click.prevent="$emit('close', false)"
            >Видмінити</a
          >
        </div>

        <div
          class="block-btn block-btn--color"
          v-else-if="list.mod == 'delete'"
        >
          <a class="btn btn-primary" @click.prevent="removeList()">Видалити</a>
          <a class="btn btn-secondary" @click.prevent="$emit('close', false)"
            >Залишити</a
          >
        </div>

        <div class="pop-up__btn" style="padding-top: 10px" v-else>
          <div class="form__checkbox" :style="list.name.mode !== 'directions' ? 'opacity:0;visibility: hidden;margin: 10px 0 0' : 'margin: 10px 0 0'">
            <label>
              <input 
                type="checkbox"
                v-model="directions.is_template"
              >
              <span>Додати в шаблони</span>
            </label>
          </div>
          <a class="btn btn-primary" @click.prevent="save()">Зберегти</a>
        </div>
        <Templates v-if="popup.flag" :idClient="list.client_id" :popup="popup" @update="updateTemplates"  @close="popup.flag = false"/>
      </div>
    </div>
  </transition>
</template>



<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.warning {
  background-image: url("data:image/svg+xml,%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 511.999 511.999' style='enable-background:new 0 0 511.999 511.999;' xml:space='preserve'%3E%3Cpath style='fill:%23E50027;' d='M501.449,368.914L320.566,66.207C306.751,43.384,282.728,29.569,256,29.569 s-50.752,13.815-64.567,36.638L10.55,368.914c-13.812,23.725-14.113,51.954-0.599,75.678c13.513,23.723,37.836,37.838,65.165,37.838 h361.766c27.329,0,51.653-14.115,65.165-37.838C515.563,420.868,515.262,392.639,501.449,368.914z'/%3E%3Cpath style='fill:%23C1001F;' d='M502.049,444.592c-13.513,23.723-37.836,37.838-65.165,37.838H256V29.57 c26.727,0,50.752,13.815,64.567,36.638L501.45,368.915C515.262,392.639,515.563,420.868,502.049,444.592z'/%3E%3Cpath style='fill:%23FD003A;' d='M75.109,452.4c-16.628,0-30.851-8.27-39.063-22.669c-8.211-14.414-8.065-31.087,0.469-45.72 L217.23,81.549c8.27-13.666,22.816-21.951,38.769-21.951s30.5,8.284,38.887,22.157l180.745,302.49 c8.388,14.4,8.534,31.072,0.322,45.485c-8.211,14.4-22.435,22.669-39.063,22.669H75.109V452.4z'/%3E%3Cpath style='fill:%23E50027;' d='M436.891,452.4c16.628,0,30.851-8.27,39.063-22.669c8.211-14.414,8.065-31.087-0.322-45.485 L294.886,81.754c-8.388-13.871-22.933-22.157-38.887-22.157V452.4H436.891z'/%3E%3Cpath style='fill:%23E1E4FB;' d='M286.03,152.095v120.122c0,16.517-13.514,30.03-30.03,30.03s-30.031-13.514-30.031-30.03V152.095 c0-16.517,13.514-30.031,30.031-30.031S286.03,135.578,286.03,152.095z'/%3E%3Cpath style='fill:%23C5C9F7;' d='M286.03,152.095v120.122c0,16.517-13.514,30.03-30.03,30.03V122.064 C272.516,122.064,286.03,135.578,286.03,152.095z'/%3E%3Cpath style='fill:%23E1E4FB;' d='M256,332.278c-24.926,0-45.046,20.119-45.046,45.046c0,24.924,20.119,45.046,45.046,45.046 s45.046-20.121,45.046-45.046C301.046,352.398,280.925,332.278,256,332.278z'/%3E%3Cpath style='fill:%23C5C9F7;' d='M301.046,377.323c0,24.924-20.119,45.046-45.046,45.046v-90.091 C280.925,332.278,301.046,352.398,301.046,377.323z'/%3E%3C/svg%3E%0A");
  width: 60px;
  height: 60px;
  margin: 0 auto 20px;
}
.copy {
  width: 60px;
  height: 60px;
  margin: 0 auto 20px;
  background-image: url("data:image/svg+xml,%0A%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 512 512' style='enable-background:new 0 0 512 512;' xml:space='preserve'%3E%3Cpath style='fill:%23FA6E51;' d='M0,256.006C0,397.402,114.606,512.004,255.996,512C397.394,512.004,512,397.402,512,256.006 C512.009,114.61,397.394,0,255.996,0C114.606,0,0,114.614,0,256.006z'/%3E%3Cpath style='fill:%23E8573F;' d='M511.393,272.788l-119.43-119.43h-0.001l-61.725-61.725c-0.634-0.636-1.394-1.142-2.235-1.494 c-0.837-0.35-1.743-0.539-2.669-0.539h-124.8c-3.828,0-6.933,3.105-6.933,6.933V131.2h-76.267c-3.828,0-6.933,3.104-6.933,6.933 v277.333c0,2.347,1.243,4.32,3.027,5.574c0.463,0.658,82.754,82.949,83.412,83.412c0.217,0.309,0.526,0.521,0.783,0.783 c18.758,4.377,38.282,6.765,58.373,6.764C391.75,512.004,502.742,406.351,511.393,272.788z'/%3E%3Cpath style='fill:%23F4F6F9;' d='M401.061,163.197c-0.352-0.842-0.859-1.6-1.494-2.235l-69.329-69.329 c-0.635-0.635-1.393-1.142-2.235-1.494c-0.838-0.35-1.744-0.539-2.67-0.539h-124.8c-3.829,0-6.933,3.104-6.933,6.933V131.2h-76.267 c-3.829,0-6.933,3.104-6.933,6.933v277.333c0,3.829,3.104,6.933,6.933,6.933h194.133c3.829,0,6.933-3.104,6.933-6.933V380.8h76.267 c3.829,0,6.933-3.104,6.933-6.933v-208C401.6,164.941,401.411,164.035,401.061,163.197z M332.267,113.27l45.663,45.663h-45.663 V113.27z M304.533,408.533H124.267V145.067H235.2v62.4c0,3.829,3.104,6.933,6.933,6.933h62.4V408.533z M294.73,200.533h-45.663 V154.87L294.73,200.533z M318.4,366.933V207.467c0-0.926-0.189-1.831-0.539-2.67c-0.352-0.842-0.859-1.6-1.494-2.235l-69.329-69.329 c-0.635-0.635-1.393-1.142-2.235-1.494c-0.838-0.35-1.744-0.539-2.67-0.539h-34.667v-27.733H318.4v62.4 c0,3.829,3.104,6.933,6.933,6.933h62.4v194.133H318.4z'/%3E%3C/svg%3E%0A");
}
</style>



<script>
import Autocomplete from "@/components/app/Autocomplete";
import DataInput from "@/components/app/DataInput";
import Templates from "@/components/selection/Templates";

export default {
  props: ["list", "application", "hidden"],

  data: () => ({
    popup: {
      flag: false,
      mod: '',
      edit: false
    },
    none: false,

    freight: {
      servant: "",
      servant_id: "",
      comment: "",
      sum: "",
      currency_payment: '',
      currency: '',
      date: "",
      payment_type: "0",
      summFull: "",
      course: 1,
    },

    kickbacks: {
      contact: "",
      contact_id: "",
      interest: "",
      numberCard: "",
      currency_payment: '',
      date: "",
      sum: "",
      currency: '',
      course: 1,
      summFull: "",
    },

    directions: {
      uploadDateFrom: "",
      uploadDateOn: "",

      unloadingDateFrom: "",
      unloadingDateOn: "",

      counterparties: "",
      counterparties_id: "",

      downloadPoint: "",
      downloadPoint_id: "",
      downloadPoint_img: "",

      addressDownload: "",

      addressClearanceIn: "",

      unloadingPoint: "",
      unloadingPoint_id: "",
      unloadingPoint_img: "",

      addressUnloading: "",

      addressClearanceOut: "",

      cargo: "",

      download_type: "",

      legalEntity: "",
      legalEntity_id: "",

      specialConditions: "",
      is_template: false,
    },

    requests: {
      carrier: '',
      freight: "",
      drivers: "",
      drivers_id: "",
      car: "",
      car_id: "",
    },

    download_type: ["Верхнє", "Заднє", "Бокове", "З зніманням стійок"],
    currency: [],
    empty: false,
    course_portal: 1,    

    carrierList: [],

    sendDisabled: false,
    //select
    params: {
      start: 0,
      limit: 50,
    },
  }),

  async created() {
    function boolean(val){
      return (val == 0) ? (false) : true
    }

    if (this.list.name.bd_name !== "requests_carrier" || this.list.name.bd_name !== "requests_carrier2"){
      this.requests.carrier = this.application.main_carrier_id
    }

  
    if (this.list.name.mode == "directions") {
      if (this.list.mod == "update" || this.list.mod == "copy") {
        this.directions.uploadDateFrom = this.list.lists[this.list.index].shipment_date_from;
        this.directions.uploadDateOn = this.list.lists[this.list.index].shipment_date_to;

        this.directions.unloadingDateFrom = this.list.lists[this.list.index].date_delivery_from;
        this.directions.unloadingDateOn = this.list.lists[this.list.index].date_delivery_to;

        this.directions.counterparties = this.list.lists[this.list.index].contractor_name;
        this.directions.counterparties_id = this.list.lists[this.list.index].contractor_id;

        this.directions.downloadPoint = this.list.lists[this.list.index].poo_name;
        this.directions.downloadPoint_id = this.list.lists[this.list.index].poo_id;

        this.directions.addressDownload = this.list.lists[this.list.index].loading_address;

        this.directions.addressClearanceIn = this.list.lists[this.list.index].customs_address_from;

        this.directions.unloadingPoint = this.list.lists[this.list.index].fd_name;
        this.directions.unloadingPoint_id = this.list.lists[this.list.index].fd_id;

        this.directions.addressUnloading = this.list.lists[this.list.index].unloading_address;

        this.directions.addressClearanceOut = this.list.lists[this.list.index].customs_address_to;

        this.directions.cargo = this.list.lists[this.list.index].cargo;

        this.directions.download_type = this.list.lists[this.list.index].download_method_id;

        this.directions.legalEntity = this.list.lists[this.list.index].legal_entity_name;
        this.directions.legalEntity_id = this.list.lists[this.list.index].legal_entity_id;

        this.directions.is_template = boolean(this.list.lists[this.list.index].add_to_templates);
      }
    }

    if (this.list.name.mode == "freight") {
      if (this.list.mod == "update" || this.list.mod == "copy") {
        this.freight.servant = this.list.lists[this.list.index].service_name;
        this.freight.servant_id = this.list.lists[this.list.index].service_id;
        this.freight.comment = this.list.lists[this.list.index].comment;
        this.freight.sum = this.list.lists[this.list.index].sum;
        this.freight.currency_payment = this.list.lists[this.list.index].currency_payment_id;
        this.freight.currency = this.list.lists[this.list.index].currency_id;
        this.freight.date = this.list.lists[this.list.index].date;
        this.freight.payment_type = this.list.lists[this.list.index].payment_type;
      }
    }
    


    //requests
    else if (this.list.name.mode == "requests") {
      if(this.list.modType == '2'){
        var app = this
        this.application.forEach(function(item, index){
          if(item.name !== ''){
            app.carrierList.push(item);
          }
        });
      }
      if (this.list.mod == "update" || this.list.mod == "copy") {
        var type = this.list.modType == 1 ? "client" : "carrier";
        var order = this.list.modCreate == "order" ? this.list.id : "0";
        var quote = this.list.modCreate == "order" ? "0" : this.list.id;

        var applicationList = await this.$store.dispatch("applicationList", {
          type,
          order,
          quote,
        });
        
        var app = this
        var dyubl = true
        this.carrierList.forEach(function(item, index){
          if(item.id == app.list.lists[app.list.index].contractor_id){
            dyubl = false
          }
        });
        if(this.list.modType == '2'){
          if(dyubl && this.list.lists[app.list.index].contractor_id !== '0'){
            this.carrierList.push({name: this.list.lists[this.list.index].contractor_name, id: this.list.lists[this.list.index].contractor_id});
          }
        }
        this.requests.carrier = this.list.lists[this.list.index].contractor_id

        var applicationList2 = applicationList.data.list[this.list.index];

        this.requests.freight = applicationList2.customer_freight_sum;

        this.requests.drivers = applicationList2.driver_name;
        this.requests.drivers_id = applicationList2.driver_id;

        this.requests.car = applicationList2.truck_name;
        this.requests.car_id = applicationList2.truck_id;
      } else {
        this.requests.carrier = 0
      }
    }
    if (this.list.name.mode == "requests" && this.list.mod == "create") {
      // this.requests.counterparties_id = this.list.carrier

      this.requests.drivers = this.application.driver;
      this.requests.drivers_id = this.application.driver_id;

      this.requests.car = this.application.truck;
      this.requests.car_id = this.application.truck_id;
    }

    //kickbacks
    else if (this.list.name.mode == "kickbacks") {
      if (this.list.mod == "update" || this.list.mod == "copy") {
        this.kickbacks.contact = this.list.lists[
          this.list.index
        ].contPerson_str;
        this.kickbacks.contact_id = this.list.lists[
          this.list.index
        ].contPerson_id;

        this.kickbacks.interest = this.list.lists[this.list.index].percent;
        this.kickbacks.numberCard = this.list.lists[
          this.list.index
        ].card_number;
        this.kickbacks.date = this.list.lists[this.list.index].created_at;
        this.kickbacks.sum = this.list.lists[this.list.index].sum;
        this.freight.currency_payment = this.list.lists[this.list.index].currency_payment_id;
        this.kickbacks.currency = this.list.lists[this.list.index].currency_id;
        // this.kickbacks.course = this.list.lists[this.list.index].exchange_rate
        if (+this.list.lists[this.list.index].exchange_rate == 0) {
          this.kickbacks.summFull = +this.list.lists[this.list.index].sum;
        } else {
          this.kickbacks.summFull = (
            +this.list.lists[this.list.index].sum /
            +this.list.lists[this.list.index].exchange_rate
          ).toFixed(2);
        }
      }
    }

    //base Currency
    const currency = await this.$store.dispatch("getCurrency", this.params);
    this.currency = currency.data.list;


    var app = this
    this.currency.forEach(function(item, index){
      if(item.name == app.$root.currencyName){
        app.course_portal = item.id;
      }
    });

    if (this.list.mod == "create") {
      this.kickbacks.currency = this.course_portal;
      this.freight.currency = this.course_portal;
    }
    this.kickbacks.currency_payment = this.course_portal;
    this.freight.currency_payment = this.course_portal;

    if (this.list.name.mode == "freight") {
      if (this.list.mod == "update" || this.list.mod == "copy") {
        if (+this.list.lists[this.list.index].exchange_rate == 0) {
          this.freight.summFull = +this.list.lists[this.list.index].sum;
        } else {
          if (this.currency[0].is_reversed !== "0") {
            this.freight.summFull = (
              +this.list.lists[this.list.index].sum *
              +this.list.lists[this.list.index].exchange_rate
            ).toFixed(2);
          } else {
            this.freight.summFull = (
              +this.list.lists[this.list.index].sum /
              +this.list.lists[this.list.index].exchange_rate
            ).toFixed(2);
          }
        }
      }
    } else if (this.list.name.mode == "kickbacks") {
      if (this.list.mod == "update" || this.list.mod == "copy") {
        if (+this.list.lists[this.list.index].exchange_rate == 0) {
          this.kickbacks.summFull = +this.list.lists[this.list.index].sum;
        } else {
          if (this.currency[0].is_reversed !== "0") {
            this.kickbacks.summFull = (
              +this.list.lists[this.list.index].sum *
              +this.list.lists[this.list.index].exchange_rate
            ).toFixed(2);
          } else {
            this.kickbacks.summFull = (
              +this.list.lists[this.list.index].sum /
              +this.list.lists[this.list.index].exchange_rate
            ).toFixed(2);
          }
        }
      }
    }

    // if(this.list.name.mode == 'freight'){
    //   var date = this.date(this.freight.date)
    //   var currency2 = this.freight.currency
    //   var res = await this.$store.dispatch('exchangeRate', {date, currency2});
    //   this.freight.course = res.data.rate
    // }
    // if(this.list.name.mode == 'kickbacks'){
    //   var date = this.date(this.kickbacks.date)
    //   var currency2 = this.kickbacks.currency
    //   var res = await this.$store.dispatch('exchangeRate', {date, currency2});
    //   this.kickbacks.course = res.data.rate
    // }
  },

  methods: {
    date(date) {
      if (date) {
        var year = date.substr(6, 4);
        var day = date.substr(0, 2);
        var month = date.substr(3, 2);
        var resultDate =
          new Date(year + "-" + month + "-" + day).getTime() / 1000;
        return resultDate;
      }
    },
    //autocomplete
    autocompleteResult(data) {
      if (this.list.name.mode == "freight") {
        this.freight[data.input] = data.name;
        this.freight[data.input + "_id"] = data.id;
      } else if (this.list.name.mode == "kickbacks") {
        this.kickbacks[data.input] = data.name;
        this.kickbacks[data.input + "_id"] = data.id;
      } else if (this.list.name.mode == "requests") {
        this.requests[data.input] = data.name;
        this.requests[data.input + "_id"] = data.id;
      } else if (this.list.name.mode == "directions") {
        this.directions[data.input] = data.name;
        this.directions[data.input + "_id"] = data.id;
      }
    },

    async dataInput(data) {
      if (this.list.name.mode == "freight") {
        var date = this.date(data.date);
        var currency2 = this.freight.currency;
        var res = await this.$store.dispatch("exchangeRate", {
          date,
          currency2,
        });
        this.freight.course = res.data.rate;
      }
      if (this.list.name.mode == "kickbacks") {
        var date = this.date(data.date);
        var currency2 = this.kickbacks.currency;
        var res = await this.$store.dispatch("exchangeRate", {
          date,
          currency2,
        });
        this.kickbacks.course = res.data.rate;
      }

      if (this.list.name.mode == "freight") {
        this.freight[data.input] = data.date;
      }
      if (this.list.name.mode == "kickbacks") {
        this.kickbacks[data.input] = data.date;
      }
      if (this.list.name.mode == "directions") {
        this.directions[data.input] = data.date;
      }
    },






    openTemplates(mod){
      this.popup.flag = true;
      this.popup.mod = mod;
    },  

    updateTemplates(data){
      this.popup.flag = false

      if(data.mod == 'download'){
        this.directions.downloadPoint_img = data.item.country_code || ''
        this.directions.downloadPoint = data.item.poo_name || ''
        this.directions.downloadPoint_id = data.item.poo_id || ''
        this.directions.addressDownload = data.item.loading_address || ''
        this.directions.addressClearanceIn = data.item.customs_address_from || ''
      } else{
        this.directions.unloadingPoint_img = data.item.country_code || ''
        this.directions.unloadingPoint = data.item.fd_name || ''
        this.directions.unloadingPoint_id = data.item.fd_id || ''
        this.directions.addressUnloading = data.item.unloading_address || ''
        this.directions.addressClearanceOut = data.item.customs_address_to || ''
        this.directions.cargo = data.item.cargo || ''
      }
    },







    async removeList() {
      var mod = this.list.modCreate == "order" ? "orders" : "quotations";
      if (this.list.name.mode == "directions") {
        const id = this.list.lists[this.list.index].id;
        const deleteList = await this.$store.dispatch("deleteDirections", {
          mod,
          id,
        });
      }

      if (this.list.name.mode == "freight") {
        const id = this.list.lists[this.list.index].id;
        if (this.list.name.bd_name == "customer_freight") {
          const deleteList = await this.$store.dispatch(
            "deleteCustomerFreight",
            { mod, id }
          );
        }
        if (this.list.name.bd_name == "carrier_freight") {
          const deleteList = await this.$store.dispatch(
            "deleteCarrierFreight",
            { mod, id }
          );
        }
        if (this.list.name.bd_name == "carrier_freight2") {
          const deleteList = await this.$store.dispatch(
            "deleteCarrierFreight2",
            { mod, id }
          );
        }
      }

      if (this.list.name.mode == "kickbacks") {
        const id = this.list.lists[this.list.index].id;
        if (this.list.name.bd_name == "kickbacks_customer") {
          const deleteList = await this.$store.dispatch("deleteKickbacks", {
            mod,
            id,
          });
        }
        if (this.list.name.bd_name == "kickbacks_carrier") {
          const deleteList = await this.$store.dispatch(
            "deleteCarrierKickbacks",
            { mod, id }
          );
        }
        if (this.list.name.bd_name == "kickbacks_carrier2") {
          const deleteList = await this.$store.dispatch(
            "deleteCarrierKickbacks2",
            { mod, id }
          );
        }
      }
      if (this.list.name.mode == "requests") {
        const id = this.list.lists[this.list.index].id;
        const deleteList = await this.$store.dispatch("deleteRequests", id);
      }

      this.$emit("close", true);
    },

    async freightCurrency(data, sum) {
      if(!sum){
        if (this.list.name.mode == "freight") {
          if(this.freight.date && this.freight.date != '0000-00-00' && this.freight.date != '0000-00-00 00:00:00'){
            var date = this.date(this.freight.date);
          } else{
            var date = new Date().getTime() / 1000
          }
          var currency2 = this.freight.currency;
          var res = await this.$store.dispatch("exchangeRate", {
            date,
            currency2,
          });
          this.freight.course = res.data.rate;
        }
        if (this.list.name.mode == "kickbacks") {
          if(this.kickbacks.date && this.freight.date != '0000-00-00' && this.freight.date != '0000-00-00 00:00:00'){
            var date = this.date(this.kickbacks.date);
          } else{
            var date = new Date().getTime() / 1000
          }
          var currency2 = this.kickbacks.currency;
          var res = await this.$store.dispatch("exchangeRate", {
            date,
            currency2,
          });
          this.kickbacks.course = res.data.rate;
        }
      }

      if (this.currency[0].is_reversed !== "0") {
        if (this.list.name.mode == "freight") {
          this.freight.summFull = (
            +this.freight.sum * +this.freight.course
          ).toFixed(2);
        } else if (this.list.name.mode == "kickbacks") {
          this.kickbacks.summFull = (
            +this.kickbacks.sum * +this.kickbacks.course
          ).toFixed(2);
        }
      } else {
        if (this.list.name.mode == "freight") {
          this.freight.summFull = (
            +this.freight.sum / +this.freight.course
          ).toFixed(2);
        } else if (this.list.name.mode == "kickbacks") {
          this.kickbacks.summFull = (
            +this.kickbacks.sum / +this.kickbacks.course
          ).toFixed(2);
        }
      }
    },

    freightCurrencyOTK(course) {
      if (this.list.name.mode == "freight") {
        if (this.currency[0].is_reversed == "0") {
          this.freight.summFull = (+this.freight.sum / +course).toFixed(2);
        } else {
          this.freight.summFull = (+this.freight.sum * +course).toFixed(2);
        }
      } else {
        if (this.currency[0].is_reversed == "0") {
          this.kickbacks.summFull = (+this.kickbacks.sum / +course).toFixed(2);
        } else {
          this.kickbacks.summFull = (+this.kickbacks.sum * +course).toFixed(2);
        }
      }
    },

    async save() {
      if(!this.sendDisabled){
        this.sendDisabled = true

        //format date
        function date(date) {
          if (date) {
            var year = date.substr(6, 4);
            var day = date.substr(0, 2);
            var month = date.substr(3, 2);
            var resultDate =
              new Date(year + "-" + month + "-" + day).getTime() / 1000;
            return resultDate;
          }
        }
        function boolean(val){
          return (val == false) ? 0 : 1
        }

        var mod = this.list.modCreate == "order" ? "orders" : "quotations";
        var id = this.list.modCreate == "order" ? "order_id" : "quote_id";

        if (this.list.name.mode == "directions") {
          // if(this.directions.is_template){
          //     var data = {
          //       customs_address_to: this.directions.addressClearanceOut || '',
          //       unloading_address: this.directions.addressUnloading || '',
          //       fd_id: this.directions.unloadingPoint_id || '',
          //       client_id: this.list.client_id,
          //     }
          //     await this.$store.dispatch('addTemplateUnloading', data)
          //     this.$emit('closePopup')

          //     var data = {
          //       customs_address_from: this.directions.addressClearanceIn || '',
          //       loading_address: this.directions.addressDownload || '',
          //       poo_id: this.directions.downloadPoint_id || '',
          //       cargo: this.directions.cargo || '',
          //       client_id: this.list.client_id,
          //     }
          //     await this.$store.dispatch('addTemplateLoading', data)
          //     this.$emit('closePopup')

          // }

          var data3 = {
            date_delivery_from: date(this.directions.unloadingDateFrom) || "",
            date_delivery_to: date(this.directions.unloadingDateOn) || "",
            shipment_date_from: date(this.directions.uploadDateFrom) || "",
            shipment_date_to: date(this.directions.uploadDateOn) || "",
            contractor_id: this.directions.counterparties_id || "",
            poo_id: this.directions.downloadPoint_id || "",
            loading_address: this.directions.addressDownload || "",
            customs_address_from: this.directions.addressClearanceIn || "",
            fd_id: this.directions.unloadingPoint_id || "",
            unloading_address: this.directions.addressUnloading || "",
            customs_address_to: this.directions.addressClearanceOut || "",
            cargo: this.directions.cargo || "",
            download_method_id: this.directions.download_type || "",
            legal_entity_id: this.directions.legalEntity_id || "",
            add_to_templates: boolean(this.directions.is_template),
          };
          var status = 0;
          for (var key in data3) {
            if (data3[key] !== "") {
              status = ++status;
            }
          }
          if (status >= 1) {
            if (this.list.mod == "update") {
              data3.id = this.list.lists[this.list.index].id;
              if (this.list.modCreate == "order") {
                var update = await this.$store.dispatch(
                  "updateDirections",
                  data3
                );
              } else {
                var ceate = await this.$store.dispatch(
                  "updateDirectionsQ",
                  data3
                );
              }
            } else {
              data3[id] = this.list.id;
              if (this.list.modCreate == "order") {
                var ceate = await this.$store.dispatch("createDirections", data3);
              } else {
                var ceate = await this.$store.dispatch(
                  "createDirectionsQ",
                  data3
                );
              }
            }
            this.empty = false;
            this.$emit("close", true);
          } else {
            this.empty = true;
          }
        }

        if (this.list.name.mode == "freight") {
          if (this.freight.date == "") {
            this.freight.date = new Intl.DateTimeFormat('ru', {day: "2-digit", month: "2-digit", year: "numeric"}).format(new Date());
          }
          var data = {
            service_id: this.freight.servant_id || "",
            comment: this.freight.comment || "",
            sum: this.freight.sum || "",
            currency_id: this.freight.currency || "",
            currency_payment_id: this.freight.currency_payment || "",
            date: date(this.freight.date) || "",
            exchange_rate: this.freight.course || "",
            payment_type: this.freight.payment_type || 0,
          };

          var status = 0;
          for (var key in data) {
            if (data[key] !== "") {
              status = ++status;
            }
          }
          if (status >= 1) {
            if (this.list.name.bd_name == "customer_freight") {
              if (this.list.mod == "update") {
                data.id = this.list.lists[this.list.index].id;
                const update = await this.$store.dispatch(
                  "updateCustomerFreight",
                  { data, mod }
                );
              } else if (this.list.mod == "copy") {
                data[id] = this.list.id;
                const update = await this.$store.dispatch(
                  "createCustomerFreight",
                  { data, mod }
                );
              } else {
                data[id] = this.list.id;
                const create = await this.$store.dispatch(
                  "createCustomerFreight",
                  { data, mod }
                );
              }
            }
            if (this.list.name.bd_name == "carrier_freight") {
              if (this.list.mod == "update") {
                data.id = this.list.lists[this.list.index].id;
                const update = await this.$store.dispatch(
                  "updateCarrierFreight",
                  { data, mod }
                );
              } else {
                data[id] = this.list.id;
                const create = await this.$store.dispatch(
                  "createCarrierFreight",
                  { data, mod }
                );
              }
            }
            if (this.list.name.bd_name == "carrier_freight2") {
              if (this.list.mod == "update") {
                data.id = this.list.lists[this.list.index].id;
                const update = await this.$store.dispatch(
                  "updateCarrierFreight2",
                  { data, mod }
                );
              } else {
                data[id] = this.list.id;
                const create = await this.$store.dispatch(
                  "createCarrierFreight2",
                  { data, mod }
                );
              }
            }
            this.empty = false;
            this.$emit("close", true);
          } else {
            this.empty = true;
          }
        }

        if (this.list.name.mode == "kickbacks") {
          var data = {
            contPerson_str: this.kickbacks.contact || "",
            contPerson_id: this.kickbacks.contact_id || "",

            percent: this.kickbacks.interest || "",
            card_number: this.kickbacks.numberCard || "",
            currency_payment_id: this.freight.currency_payment || "",
            date: date(this.kickbacks.date) || "",
            sum: this.kickbacks.sum || "",
            currency_id: this.kickbacks.currency || "",
            exchange_rate: this.kickbacks.course || "",
          };

          var status = 0;
          for (var key in data) {
            if (data[key] !== "") {
              status = ++status;
            }
          }
          if (status >= 1) {
            if (this.list.name.bd_name == "kickbacks_customer") {
              if (this.list.mod == "update") {
                data.id = this.list.lists[this.list.index].id;
                const update = await this.$store.dispatch("updateKickbacks", {
                  data,
                  mod,
                });
              } else {
                data[id] = this.list.id;
                const create = await this.$store.dispatch("createKickbacks", {
                  data,
                  mod,
                });
              }
            }
            if (this.list.name.bd_name == "kickbacks_carrier") {
              if (this.list.mod == "update") {
                data.id = this.list.lists[this.list.index].id;
                const update = await this.$store.dispatch(
                  "updateCarrierKickbacks",
                  { data, mod }
                );
              } else {
                data[id] = this.list.id;
                const create = await this.$store.dispatch(
                  "createCarrierKickbacks",
                  { data, mod }
                );
              }
            }
            if (this.list.name.bd_name == "kickbacks_carrier2") {
              if (this.list.mod == "update") {
                data.id = this.list.lists[this.list.index].id;
                const update = await this.$store.dispatch(
                  "updateCarrierKickbacks2",
                  { data, mod }
                );
              } else {
                data[id] = this.list.id;
                const create = await this.$store.dispatch(
                  "createCarrierKickbacks2",
                  { data, mod }
                );
              }
            }
            this.empty = false;
            this.$emit("close", true);
          } else {
            this.empty = true;
          }
        }

        if (this.list.name.mode == "requests") {
          var data = {
            customer_freight_sum: this.requests.freight || "",
            driver_id: this.requests.drivers_id || "",
            truck_id: this.requests.car_id || "",
            trailer_id: this.requests.trailers_id || "",
          };
          var status = 0;
          for (var key in data) {
            if (data[key] !== "") {
              status = ++status;
            }
          }
          if (status >= 1) {
            if (
              this.list.name.bd_name == "requests_carrier" ||
              this.list.name.bd_name == "requests_carrier2"
            ) {
              data.contractor_id = this.requests.carrier || '';
            }

            if (this.list.mod == "update") {
              data.id = this.list.lists[this.list.index].id;
              const update = await this.$store.dispatch("updateRequests", data);
            } else {
              data.doc_type = this.list.modCreate;
              data.doc_id = this.list.id;
              data.with_type = this.list.modType;
              const create = await this.$store.dispatch("createRequests", data);
            }
            this.empty = false;
            this.$emit("close", true);
          } else {
            this.empty = true;
          }
        }
      }
    },
  },

  components: {
    Autocomplete,
    DataInput,
    Templates,
  },
};
</script>